import { Link } from "react-router-dom";
import { Box, Button, Grid, Typography, useTheme } from "@mui/material";

import { ROUTES } from "@/utils/navigation";
import solutionsUrl from "@/assets/images/navbar/solutions-map.png";
import solutionsThumbUrl from "@/assets/images/navbar/solutions-map_thumbnail.png";
import useResponsive from "@/hooks/useResponsive";

import AnimatedImage from "@/components/UI-Kit/AnimatedImage";
import SubMenuHeading from "../../SubMenuHeading";
import { platformMapContainerStyles } from "../styles";

interface IProps {
  closeDropDown: () => void;
}

const Platform: React.FC<IProps> = ({ closeDropDown }) => {
  const isMobile = useResponsive("down", "lg");
  const theme = useTheme();

  return (
    <>
      <SubMenuHeading title="Our Platform" />
      <Box
        component={Link}
        to={ROUTES.subscriptionPlans}
        onClick={closeDropDown}
        display="block"
        mb={{ xs: 1, lg: 2 }}
        sx={{ textDecoration: "none" }}
      >
        <AnimatedImage
          sx={{
            ...platformMapContainerStyles,
            img: { width: "100%", height: "100%", objectFit: "contain" },
          }}
          thumbnailUrl={solutionsThumbUrl}
          mainUrl={solutionsUrl}
          alt="solutions-map"
        />
        <Typography
          color="text.primary"
          variant={isMobile ? "subtitle1" : "h6"}
          fontWeight={700}
        >
          Get on Board with Trackmate
        </Typography>
      </Box>

      {isMobile ? (
        <Grid container mb={1}>
          {"Take the first step towards efficiency, safety, and unparalleled control. Get our platform and revolutionize your fleet management journey."
            .split(" ")
            .map((word, index) => (
              <Grid
                item
                key={index}
                xs="auto"
                sx={{ paddingY: 0, paddingX: 0.25 }}
              >
                <Typography
                  variant="body2"
                  component="span"
                  color={theme.palette.grey[600]}
                >
                  {word}
                </Typography>
              </Grid>
            ))}
        </Grid>
      ) : (
        <Typography variant="body1" fontWeight={400} mb={3}>
          Take the first step towards efficiency, safety, and unparalleled
          control. Get our platform and revolutionize your fleet management
          journey.
        </Typography>
      )}

      <Typography variant="body1" fontWeight={700} mb={{ xs: 0.5, lg: 3.5 }}>
        Starts from $9.99
      </Typography>

      <Button
        component={Link}
        to={ROUTES.features}
        onClick={closeDropDown}
        variant="text"
        color="primary"
        sx={{ paddingX: 0, fontWeight: 700 }}
      >
        <Typography
          variant="subtitle1"
          component="span"
          color="inherit"
          fontWeight="inherit"
        >
          View features
        </Typography>
      </Button>
    </>
  );
};

export default Platform;
